import axios from "axios";
import { atom, selector } from "recoil";
import { COMMUNICATE_ERROR_MESSAGE_HISTORICAL_AIRCRAFT_LIST, COMMUNICATE_ERROR_MESSAGE_PAST_DATA, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../constants/ErrorMessage";
import { userState } from "./UserState";

const getFlightHistory = async (flightHistoryTarget, userGroup) => {
  if (!flightHistoryTarget.type) {
    return {}
  };

  let type = 'geojson';
  if (flightHistoryTarget.type === 'csv') {
    type = 'csv_position';
  } else if (flightHistoryTarget.type === 'alert') {
    type = 'csv_alert';
  }
  const apiUrl = process.env.REACT_APP_HISTORICAL_API_URL;
  const apiKey = process.env.REACT_APP_HISTORICAL_API_KEY;
  return axios.get(`${apiUrl}/past_data/${type}`, {
    params: {
      aircraft_code: flightHistoryTarget.aircraft_code,
      start: flightHistoryTarget.from,
      end: flightHistoryTarget.to,
      usergroup_id: userGroup
    },
    headers: {
      'x-api-key': apiKey
    },
    errorHandle: {
      message: COMMUNICATE_ERROR_MESSAGE_PAST_DATA,
      replacement: {type: type},
      additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER,
      exclusionStatus: [404]
    }
  }).then(res => {
    return res.data;
  }).catch(e => {
    if (e.response?.status === 404) {
      return {features: []};
    }
    console.error('flightHistoryData load failed.', e);
    return {};
  });
}

export const flightHistoryTargetState = atom({
  key: 'flightHistoryTargetState',
  default: {
    type: '',
    from: '',
    to: '',
    aircraft_code: ''
  }
});

export const flightHistoryState = atom({
  key: 'flightHistoryState',
  default: selector({
    key: 'flightHistoryStateSelector',
    get: async ({get}) => {
      const targetState = get(flightHistoryTargetState);
      const userGroup = get(userState).group;
      return await getFlightHistory(targetState, userGroup);
    }
  })
});

export const flightHistoryWindowState = atom({
  key: 'flightHistoryWindowState',
  default: []
});

export const flightHistoryDataLoadingState = atom({
  key: 'flightHistoryDataLoadingState',
  default: false
});

export const flightHistoryTooltipControllerState = atom({
  key: 'flightHistoryTooltipControllerState',
  default: []
});

export const flightHistorySources = atom({
  key: 'flightHistorySources',
  default: []
})

const getHistoryAircraftList = async (userGroup) => {

  const apiUrl = process.env.REACT_APP_AIRCRAFT_LINKAGE_API_URL;
  const apiKey = process.env.REACT_APP_AIRCRAFT_LINKAGE_API_KEY;
  return axios.get(`${apiUrl}/links/historical_aircraft_list`, {
    params: {
      usergroup_id : userGroup
    },
    headers: {
      'x-api-key': apiKey
    },
    errorHandle: {
      message: COMMUNICATE_ERROR_MESSAGE_HISTORICAL_AIRCRAFT_LIST,
      additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
    }
  }).then(res => {
    return res.data;
  }).catch(e => {
    console.error('flightHistoryData load failed.', e);
    return [];
  });
}

export const historyAircraftListState = atom({
  key: 'historyAircraftListState',
  default: selector({
    key: 'historyAircraftListSelector',
    get: async ({get}) => {
      const userGroup = get(userState).group;
      return await getHistoryAircraftList(userGroup);
    }
  })
})
